<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-19 09:42:50
 * @LastEditTime : 2020-01-09 18:09:20
 * @LastEditors  : Please set LastEditors
 -->
<!-- 搜索结果poi选择 -->
<template>
  <div class="divUCSearchPOIResult">

    <el-main style="padding: 0px">
      <ul>
        <li
          class="li_item"
          v-for="item in routePOI.searchPOIs"
          :key="item.id"
          @mouseover="_poiItemMouseOverHandler(item)"
          @mouseout="_poiItemMouseOutHandler(item)"
        >

          <div>
            <img
              :src="item.image"
              class="img_item"
            >
          </div>

          <div class="div_item_content">
            <span class="span_item_name"> {{item.name}}</span>
            <span v-show="item.phone"> {{item.phone}}</span>
            <span v-show="item.address">{{"地址:" + item.address}}</span>
          </div>

          <div class="div_item_set">
            <span
              v-show="item.focusStatus"
              @click="_poiItemPickClickHandler(item)"
              @mouseOver="_poiItemPickMouseOverHandler"
              @mouseout="_poiItemPickMouseOutHandler"
            >{{selectPointSpan}}</span>

          </div>

        </li>

      </ul>
    </el-main>

    <el-footer
      v-show="ucSetting.pagination.count>0"
      style="height:40px"
    >
      <el-pagination
        @current-change="_paginationCurrentChange"
        :page-size="ucSetting.pagination.pageSize"
        :current-page.sync="ucSetting.pagination.curPageIndex"
        :pager-count="ucSetting.pagination.pagerCount"
        layout="prev, pager"
        :total="ucSetting.pagination.count"
      ></el-pagination>
    </el-footer>

    <div
      v-show="ucSetting.no_POITip"
      class="div_span_noPOI"
    >
      <span class="span_noPOI">该地图级别范围下未查询到相关POI点</span>
    </div>

  </div>
</template>

<script>
import { POIResultItems, POISurroundType } from "../model/POISearch.js";
import { UCRouteEvent, RoutePOIInfo } from "./UCRouteJs.js";
import { AssetsConfig } from "../../../config/AssetsConfig.js";

export default {
  name: "UCSearchPOIResult",
  data() {
    return {
      routePOI: new RoutePOIInfo(),

      // pois:new Array(),

      selectPointSpan: "选取该点",

      curFilter: null,

      poiSurroundType: null,

      ucSetting: {
        pagination: {
          //每页的个数
          pageSize: 10,
          //当前索引
          curPageIndex: 1,
          //显示页数
          pagerCount: 5,
          //总数
          count: -1
        },

        no_POITip: false
      }
    };
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {
    init() {
      if (this.poiSurroundType === POISurroundType.type_route_startPOI) {
        this.selectPointSpan = "设为起点";
      } else if (this.poiSurroundType === POISurroundType.type_route_viaPOI) {
        this.selectPointSpan = "设为途经点";
      } else if (this.poiSurroundType === POISurroundType.type_route_endPOI) {
        this.selectPointSpan = "设为终点";
      }

      //默认为第一页
      this._paginationCurrentChange(1);
    },

    off_poiItemPickClick(callback) {
      if (callback) {
        this.$off(UCRouteEvent.UCSearchPOIResult_POIItemPickClick, callback);
      }
    },

    on_poiItemPickClick(callback) {
      if (callback) {
        this.$on(UCRouteEvent.UCSearchPOIResult_POIItemPickClick, callback);
      }
    },

    off_poiSearchFinished(callback) {
      if (callback) {
        this.$off(
          UCRouteEvent.UCSearchPOIResult_searchResultFinished,
          callback
        );
      }
    },

    on_poiSearchFinished(callback) {
      if (callback) {
        this.$on(UCRouteEvent.UCSearchPOIResult_searchResultFinished, callback);
      }
    },

    /**
     * 当前页索引改变
     */
    _paginationCurrentChange(pageIndex) {
      let self = this;
      if (pageIndex <= 0 || !this.ucSetting.pagination) return;

      this.ucSetting.pagination.curPageIndex = pageIndex;

      let startIndex = this.ucSetting.pagination.pageSize * (pageIndex - 1);
      self.curFilter.startIndex = startIndex;
      // self.curFilter.filterType = POISearchFilterType.national_common;

      POIResultItems.search(
        self.curFilter,
        function(searchResult) {
          if (searchResult) {
            self._setImagesForPoi(searchResult.objects);
          }

          self.routePOI.searchPOIs = searchResult.objects;
          self.ucSetting.pagination.count = searchResult.count;

          if (self.ucSetting.pagination.count <= 0) {
            self.ucSetting.no_POITip = true;
          } else {
            self.ucSetting.no_POITip = false;
          }

          //触发改变事件
          self.$emit(
            UCRouteEvent.UCSearchPOIResult_searchResultFinished,
            self.routePOI.searchPOIs
          );
        },
        function(error) {
          self.ucSetting.no_POITip = true;
        }
      );
    },

    _setImagesForPoi(pois) {
      let tempPoi = null;
      let poiIconIndex = -1;
      for (let tempPoiIndex in pois) {
        poiIconIndex = parseInt(tempPoiIndex) + 1;
        tempPoi = pois[tempPoiIndex];
        tempPoi.ucfocusImage = AssetsConfig.getPOIIcon(poiIconIndex, true);
        tempPoi.focusImage = AssetsConfig.getPOIIcon(poiIconIndex, false);

        tempPoi.image = tempPoi.ucfocusImage;
      }
    },

    _poiItemMouseOverHandler(curPoi) {
      curPoi.focusStatus = true;

      // curPoi.image = curPoi.focusImage;

      // this.$emit(UCPOISearchEvent.UCPOIResultPaging_poiItemMouseOver, curPoi);
    },

    _poiItemMouseOutHandler(curPoi) {
      curPoi.focusStatus = false;
      // curPoi.image = curPoi.ucfocusImage;

      // this.$emit(UCPOISearchEvent.UCPOIResultPaging_poiItemMouseOut, curPoi);
    },

    _poiItemPickClickHandler(poiItem) {
      this.routePOI.POI = poiItem;
      this.routePOI.selectStatus = true;

      this.$emit(UCRouteEvent.UCSearchPOIResult_POIItemPickClick, poiItem);
    },

    _poiItemPickMouseOverHandler() {},

    _poiItemPickMouseOutHandler() {}
  }
};
</script>
<style lang="scss" scoped>
.divUCSearchPOIResult {
  width: 100%;
  //修改字体
  font-size: 12px;

  .li_item {
    display: flex;
    // flex-direction: row;
    // justify-content: flex-start;
    .img_item {
      padding-top: 10px;
    }

    .div_item_content {
      margin-left: 5px;
      padding: 10px 0;
      line-height: 24px;
      width: 170px;
      float: left;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .span_item_name {
        color: #2f87eb;
      }
    }

    .div_item_set {
      color: #2f87eb;
      cursor: pointer;
      float: right;
      margin-top: 10px;
      margin-left:auto;
    }
  }

  .div_span_noPOI {
    text-align: center;

    .span_noPOI {
      color: #2f87eb;
      font-size: 16px;
      display: inline-block;
    }
  }
}
</style>
